import { isExternalFlow } from './productIntegrationUtils';
import templateData from './getTemplateData';
import { isInContext } from './inContextDonation';

// eslint-disable-next-line max-params
function getSocialCampaign(
  messages,
  orgName,
  hostedButtonId,
  campaignId,
  socialTitle,
  email
) {
  const {
    emailSubject = '',
    emailBody = '',
    mobileText = '',
    facebookMessage = '',
    twitterMessage = '',
    whatsappMessage = '',
    copyLinkHeader = '',
    copyLinkSubheaderBefore = '',
    copyLinkSubheader = '',
    copyText = '',
    copiedText = '',
  } = messages || {};
  const domain = templateData.paypalHostName;

  const shareableUrl =
    // eslint-disable-next-line no-nested-ternary
    hostedButtonId
      ? `${domain}/donate/?'hosted_button_id'=${hostedButtonId}&source=url`
      : campaignId
      ? `${domain}/donate/?campaign_id=${campaignId}&source=url`
      : `${domain}/donate/?business=${email}&source=url`;

  const socialCampaign = {
    email: true,
    emailSubject: encodeURIComponent(
      emailSubject.replace('{donationName}', orgName)
    ),
    emailBody: encodeURIComponent(
      emailBody
        .replace(new RegExp('<br>', 'g'), '\r\n')
        .replace('{donationName}', orgName)
        .replace('{url}', shareableUrl)
    ),
    mobile: true,
    mobileTitle: encodeURIComponent(
      emailSubject.replace('{donationName}', orgName)
    ),
    mobileText: mobileText.replace('{donationName}', orgName),
    facebook: true,
    facebookMessage: facebookMessage
      .replace('{donationName}', orgName)
      .replace('{url}', shareableUrl),
    facebookMessenger: true,
    whatsapp: true,
    whatsappMessage: encodeURIComponent(
      whatsappMessage
        .replace(new RegExp('<br>', 'g'), '\r\n')
        .replace('{donationName}', orgName)
    ),
    twitter: true,
    twitterMessage: twitterMessage.replace('{donationName}', orgName),
    copyLink: isInContext() && isExternalFlow() ? false : true,
    copyLinkHeader,
    copyLinkSubheaderBefore,
    copyLinkSubheader,
    copyLinkCopy: copyText,
    copyLinkCopied: copiedText,
    title: socialTitle,
    sheet: messages.sheet,
  };

  return socialCampaign;
}

export default getSocialCampaign;
